export const GET_USER_BY_MAIL_ENDPOINT = 'api/users/';
export const USERS_ENDPOINT = 'api/users';
export const GET_MENU_BY_BRANDNAME_ENDPOINT = 'api/menu/';
export const CREATE_USER_ENDPOINT = 'api/users';
export const UPDATE_USER_MENU_ENDPOINT = 'api/users/';
export const UPDATE_USER_DATA_ENDPOINT = 'api/users/';
export const PAYKU_CONTROLLER_ENDPOINT = 'api/payku/';
export const CATEGORY_CONTROLLER_ENDPOINT = 'api/categories';
export const COIN_CONTROLLER_ENDPOINT = 'api/coins';
export const COUNTRY_CONTROLLER_ENDPOINT = 'api/countrys';

export const NEW_SUSCRIPTION = {
    clientId: null,
    planId: null
}


export const NEW_USER = {
    "address": "Ingrese una direccion",
    "brandName": null,
    "categoryId": 1,
    "coin": 1,
    "deliveryCharge": 0,
    "description": "Ingrese una description",
    "minDelivery": 0,
    "name": "Ingrese un nombre",
    "open": true,
    "opening": "Ingrese horario de atencion",
    "paymentInstructions": "Ingrese instrucciones de pago",
    "phoneNumber": 44444444,
    "countryId": 41,
    "base64Image": null
}

export const USER_DATA = {
    "address": null,
    "brandName": null,
    "categoryId": null,
    "coin": null,
    "description": null,
    "deliveryCharge": null,
    "minDelivery": null,
    "email": null,
    "name": null,
    "open": null,
    "opening": null,
    "paymentInstructions": null,
    "phoneNumber": null,
    "countryId": null,
    "username": null,
    "orderViaId": null,
    "base64Image": null
}

export const NEW_ORDER = {
    "client": null,
    "contact": null,
    "total": null,
    "type": null,
    "orderNumber": null,
    "products": null

}
export const COUNTRIES = [
    {
        "id": 1,
        "nombre": "Afganistán",
        "name": "Afghanistan",
        "nom": "Afghanistan",
        "iso2": "AF",
        "iso3": "AFG",
        "phone_code": "93"
    },
    {
        "id": 2,
        "nombre": "Albania",
        "name": "Albania",
        "nom": "Albanie",
        "iso2": "AL",
        "iso3": "ALB",
        "phone_code": "355"
    },
    {
        "id": 3,
        "nombre": "Alemania",
        "name": "Germany",
        "nom": "Allemagne",
        "iso2": "DE",
        "iso3": "DEU",
        "phone_code": "49"
    },
    {
        "id": 4,
        "nombre": "Algeria",
        "name": "Algeria",
        "nom": "Algérie",
        "iso2": "DZ",
        "iso3": "DZA",
        "phone_code": "213"
    },
    {
        "id": 5,
        "nombre": "Andorra",
        "name": "Andorra",
        "nom": "Andorra",
        "iso2": "AD",
        "iso3": "AND",
        "phone_code": "376"
    },
    {
        "id": 6,
        "nombre": "Angola",
        "name": "Angola",
        "nom": "Angola",
        "iso2": "AO",
        "iso3": "AGO",
        "phone_code": "244"
    },
    {
        "id": 7,
        "nombre": "Anguila",
        "name": "Anguilla",
        "nom": "Anguilla",
        "iso2": "AI",
        "iso3": "AIA",
        "phone_code": "1 264"
    },
    {
        "id": 8,
        "nombre": "Antártida",
        "name": "Antarctica",
        "nom": "LAntarctique",
        "iso2": "AQ",
        "iso3": "ATA",
        "phone_code": "672"
    },
    {
        "id": 9,
        "nombre": "Antigua y Barbuda",
        "name": "Antigua and Barbuda",
        "nom": "Antigua et Barbuda",
        "iso2": "AG",
        "iso3": "ATG",
        "phone_code": "1 268"
    },
    {
        "id": 10,
        "nombre": "Antillas Neerlandesas",
        "name": "Netherlands Antilles",
        "nom": "Antilles Néerlandaises",
        "iso2": "AN",
        "iso3": "ANT",
        "phone_code": "599"
    },
    {
        "id": 11,
        "nombre": "Arabia Saudita",
        "name": "Saudi Arabia",
        "nom": "Arabie Saoudite",
        "iso2": "SA",
        "iso3": "SAU",
        "phone_code": "966"
    },
    {
        "id": 12,
        "nombre": "Argentina",
        "name": "Argentina",
        "nom": "Argentine",
        "iso2": "AR",
        "iso3": "ARG",
        "phone_code": "54"
    },
    {
        "id": 13,
        "nombre": "Armenia",
        "name": "Armenia",
        "nom": "LArménie",
        "iso2": "AM",
        "iso3": "ARM",
        "phone_code": "374"
    },
    {
        "id": 14,
        "nombre": "Aruba",
        "name": "Aruba",
        "nom": "Aruba",
        "iso2": "AW",
        "iso3": "ABW",
        "phone_code": "297"
    },
    {
        "id": 15,
        "nombre": "Australia",
        "name": "Australia",
        "nom": "Australie",
        "iso2": "AU",
        "iso3": "AUS",
        "phone_code": "61"
    },
    {
        "id": 16,
        "nombre": "Austria",
        "name": "Austria",
        "nom": "Autriche",
        "iso2": "AT",
        "iso3": "AUT",
        "phone_code": "43"
    },
    {
        "id": 17,
        "nombre": "Azerbayán",
        "name": "Azerbaijan",
        "nom": "LAzerbaïdjan",
        "iso2": "AZ",
        "iso3": "AZE",
        "phone_code": "994"
    },
    {
        "id": 18,
        "nombre": "Bélgica",
        "name": "Belgium",
        "nom": "Belgique",
        "iso2": "BE",
        "iso3": "BEL",
        "phone_code": "32"
    },
    {
        "id": 19,
        "nombre": "Bahamas",
        "name": "Bahamas",
        "nom": "Bahamas",
        "iso2": "BS",
        "iso3": "BHS",
        "phone_code": "1 242"
    },
    {
        "id": 20,
        "nombre": "Bahrein",
        "name": "Bahrain",
        "nom": "Bahreïn",
        "iso2": "BH",
        "iso3": "BHR",
        "phone_code": "973"
    },
    {
        "id": 21,
        "nombre": "Bangladesh",
        "name": "Bangladesh",
        "nom": "Bangladesh",
        "iso2": "BD",
        "iso3": "BGD",
        "phone_code": "880"
    },
    {
        "id": 22,
        "nombre": "Barbados",
        "name": "Barbados",
        "nom": "Barbade",
        "iso2": "BB",
        "iso3": "BRB",
        "phone_code": "1 246"
    },
    {
        "id": 23,
        "nombre": "Belice",
        "name": "Belize",
        "nom": "Belize",
        "iso2": "BZ",
        "iso3": "BLZ",
        "phone_code": "501"
    },
    {
        "id": 24,
        "nombre": "Benín",
        "name": "Benin",
        "nom": "Bénin",
        "iso2": "BJ",
        "iso3": "BEN",
        "phone_code": "229"
    },
    {
        "id": 25,
        "nombre": "Bhután",
        "name": "Bhutan",
        "nom": "Le Bhoutan",
        "iso2": "BT",
        "iso3": "BTN",
        "phone_code": "975"
    },
    {
        "id": 26,
        "nombre": "Bielorrusia",
        "name": "Belarus",
        "nom": "Biélorussie",
        "iso2": "BY",
        "iso3": "BLR",
        "phone_code": "375"
    },
    {
        "id": 27,
        "nombre": "Birmania",
        "name": "Myanmar",
        "nom": "Myanmar",
        "iso2": "MM",
        "iso3": "MMR",
        "phone_code": "95"
    },
    {
        "id": 28,
        "nombre": "Bolivia",
        "name": "Bolivia",
        "nom": "Bolivie",
        "iso2": "BO",
        "iso3": "BOL",
        "phone_code": "591"
    },
    {
        "id": 29,
        "nombre": "Bosnia y Herzegovina",
        "name": "Bosnia and Herzegovina",
        "nom": "Bosnie-Herzégovine",
        "iso2": "BA",
        "iso3": "BIH",
        "phone_code": "387"
    },
    {
        "id": 30,
        "nombre": "Botsuana",
        "name": "Botswana",
        "nom": "Botswana",
        "iso2": "BW",
        "iso3": "BWA",
        "phone_code": "267"
    },
    {
        "id": 31,
        "nombre": "Brasil",
        "name": "Brazil",
        "nom": "Brésil",
        "iso2": "BR",
        "iso3": "BRA",
        "phone_code": "55"
    },
    {
        "id": 32,
        "nombre": "Brunéi",
        "name": "Brunei",
        "nom": "Brunei",
        "iso2": "BN",
        "iso3": "BRN",
        "phone_code": "673"
    },
    {
        "id": 33,
        "nombre": "Bulgaria",
        "name": "Bulgaria",
        "nom": "Bulgarie",
        "iso2": "BG",
        "iso3": "BGR",
        "phone_code": "359"
    },
    {
        "id": 34,
        "nombre": "Burkina Faso",
        "name": "Burkina Faso",
        "nom": "Burkina Faso",
        "iso2": "BF",
        "iso3": "BFA",
        "phone_code": "226"
    },
    {
        "id": 35,
        "nombre": "Burundi",
        "name": "Burundi",
        "nom": "Burundi",
        "iso2": "BI",
        "iso3": "BDI",
        "phone_code": "257"
    },
    {
        "id": 36,
        "nombre": "Cabo Verde",
        "name": "Cape Verde",
        "nom": "Cap-Vert",
        "iso2": "CV",
        "iso3": "CPV",
        "phone_code": "238"
    },
    {
        "id": 37,
        "nombre": "Camboya",
        "name": "Cambodia",
        "nom": "Cambodge",
        "iso2": "KH",
        "iso3": "KHM",
        "phone_code": "855"
    },
    {
        "id": 38,
        "nombre": "Camerún",
        "name": "Cameroon",
        "nom": "Cameroun",
        "iso2": "CM",
        "iso3": "CMR",
        "phone_code": "237"
    },
    {
        "id": 39,
        "nombre": "Canadá",
        "name": "Canada",
        "nom": "Canada",
        "iso2": "CA",
        "iso3": "CAN",
        "phone_code": "1"
    },
    {
        "id": 40,
        "nombre": "Chad",
        "name": "Chad",
        "nom": "Tchad",
        "iso2": "TD",
        "iso3": "TCD",
        "phone_code": "235"
    },
    {
        "id": 41,
        "nombre": "Chile",
        "name": "Chile",
        "nom": "Chili",
        "iso2": "CL",
        "iso3": "CHL",
        "phone_code": "56"
    },
    {
        "id": 42,
        "nombre": "China",
        "name": "China",
        "nom": "Chine",
        "iso2": "CN",
        "iso3": "CHN",
        "phone_code": "86"
    },
    {
        "id": 43,
        "nombre": "Chipre",
        "name": "Cyprus",
        "nom": "Chypre",
        "iso2": "CY",
        "iso3": "CYP",
        "phone_code": "357"
    },
    {
        "id": 44,
        "nombre": "Ciudad del Vaticano",
        "name": "Vatican City State",
        "nom": "Cité du Vatican",
        "iso2": "VA",
        "iso3": "VAT",
        "phone_code": "39"
    },
    {
        "id": 45,
        "nombre": "Colombia",
        "name": "Colombia",
        "nom": "Colombie",
        "iso2": "CO",
        "iso3": "COL",
        "phone_code": "57"
    },
    {
        "id": 46,
        "nombre": "Comoras",
        "name": "Comoros",
        "nom": "Comores",
        "iso2": "KM",
        "iso3": "COM",
        "phone_code": "269"
    },
    {
        "id": 47,
        "nombre": "Congo",
        "name": "Congo",
        "nom": "Congo",
        "iso2": "CG",
        "iso3": "COG",
        "phone_code": "242"
    },
    {
        "id": 48,
        "nombre": "Congo",
        "name": "Congo",
        "nom": "Congo",
        "iso2": "CD",
        "iso3": "COD",
        "phone_code": "243"
    },
    {
        "id": 49,
        "nombre": "Corea del Norte",
        "name": "North Korea",
        "nom": "Corée du Nord",
        "iso2": "KP",
        "iso3": "PRK",
        "phone_code": "850"
    },
    {
        "id": 50,
        "nombre": "Corea del Sur",
        "name": "South Korea",
        "nom": "Corée du Sud",
        "iso2": "KR",
        "iso3": "KOR",
        "phone_code": "82"
    },
    {
        "id": 51,
        "nombre": "Costa de Marfil",
        "name": "Ivory Coast",
        "nom": "Côte-dIvoire",
        "iso2": "CI",
        "iso3": "CIV",
        "phone_code": "225"
    },
    {
        "id": 52,
        "nombre": "Costa Rica",
        "name": "Costa Rica",
        "nom": "Costa Rica",
        "iso2": "CR",
        "iso3": "CRI",
        "phone_code": "506"
    },
    {
        "id": 53,
        "nombre": "Croacia",
        "name": "Croatia",
        "nom": "Croatie",
        "iso2": "HR",
        "iso3": "HRV",
        "phone_code": "385"
    },
    {
        "id": 54,
        "nombre": "Cuba",
        "name": "Cuba",
        "nom": "Cuba",
        "iso2": "CU",
        "iso3": "CUB",
        "phone_code": "53"
    },
    {
        "id": 55,
        "nombre": "Dinamarca",
        "name": "Denmark",
        "nom": "Danemark",
        "iso2": "DK",
        "iso3": "DNK",
        "phone_code": "45"
    },
    {
        "id": 56,
        "nombre": "Dominica",
        "name": "Dominica",
        "nom": "Dominique",
        "iso2": "DM",
        "iso3": "DMA",
        "phone_code": "1 767"
    },
    {
        "id": 57,
        "nombre": "Ecuador",
        "name": "Ecuador",
        "nom": "Equateur",
        "iso2": "EC",
        "iso3": "ECU",
        "phone_code": "593"
    },
    {
        "id": 58,
        "nombre": "Egipto",
        "name": "Egypt",
        "nom": "Egypte",
        "iso2": "EG",
        "iso3": "EGY",
        "phone_code": "20"
    },
    {
        "id": 59,
        "nombre": "El Salvador",
        "name": "El Salvador",
        "nom": "El Salvador",
        "iso2": "SV",
        "iso3": "SLV",
        "phone_code": "503"
    },
    {
        "id": 60,
        "nombre": "Emiratos Árabes Unidos",
        "name": "United Arab Emirates",
        "nom": "Emirats Arabes Unis",
        "iso2": "AE",
        "iso3": "ARE",
        "phone_code": "971"
    },
    {
        "id": 61,
        "nombre": "Eritrea",
        "name": "Eritrea",
        "nom": "Erythrée",
        "iso2": "ER",
        "iso3": "ERI",
        "phone_code": "291"
    },
    {
        "id": 62,
        "nombre": "Eslovaquia",
        "name": "Slovakia",
        "nom": "Slovaquie",
        "iso2": "SK",
        "iso3": "SVK",
        "phone_code": "421"
    },
    {
        "id": 63,
        "nombre": "Eslovenia",
        "name": "Slovenia",
        "nom": "Slovénie",
        "iso2": "SI",
        "iso3": "SVN",
        "phone_code": "386"
    },
    {
        "id": 64,
        "nombre": "España",
        "name": "Spain",
        "nom": "Espagne",
        "iso2": "ES",
        "iso3": "ESP",
        "phone_code": "34"
    },
    {
        "id": 65,
        "nombre": "Estados Unidos de América",
        "name": "United States of America",
        "nom": "États-Unis dAmérique",
        "iso2": "US",
        "iso3": "USA",
        "phone_code": "1"
    },
    {
        "id": 66,
        "nombre": "Estonia",
        "name": "Estonia",
        "nom": "LEstonie",
        "iso2": "EE",
        "iso3": "EST",
        "phone_code": "372"
    },
    {
        "id": 67,
        "nombre": "Etiopía",
        "name": "Ethiopia",
        "nom": "Ethiopie",
        "iso2": "ET",
        "iso3": "ETH",
        "phone_code": "251"
    },
    {
        "id": 68,
        "nombre": "Filipinas",
        "name": "Philippines",
        "nom": "Philippines",
        "iso2": "PH",
        "iso3": "PHL",
        "phone_code": "63"
    },
    {
        "id": 69,
        "nombre": "Finlandia",
        "name": "Finland",
        "nom": "Finlande",
        "iso2": "FI",
        "iso3": "FIN",
        "phone_code": "358"
    },
    {
        "id": 70,
        "nombre": "Fiyi",
        "name": "Fiji",
        "nom": "Fidji",
        "iso2": "FJ",
        "iso3": "FJI",
        "phone_code": "679"
    },
    {
        "id": 71,
        "nombre": "Francia",
        "name": "France",
        "nom": "France",
        "iso2": "FR",
        "iso3": "FRA",
        "phone_code": "33"
    },
    {
        "id": 72,
        "nombre": "Gabón",
        "name": "Gabon",
        "nom": "Gabon",
        "iso2": "GA",
        "iso3": "GAB",
        "phone_code": "241"
    },
    {
        "id": 73,
        "nombre": "Gambia",
        "name": "Gambia",
        "nom": "Gambie",
        "iso2": "GM",
        "iso3": "GMB",
        "phone_code": "220"
    },
    {
        "id": 74,
        "nombre": "Georgia",
        "name": "Georgia",
        "nom": "Géorgie",
        "iso2": "GE",
        "iso3": "GEO",
        "phone_code": "995"
    },
    {
        "id": 75,
        "nombre": "Ghana",
        "name": "Ghana",
        "nom": "Ghana",
        "iso2": "GH",
        "iso3": "GHA",
        "phone_code": "233"
    },
    {
        "id": 76,
        "nombre": "Gibraltar",
        "name": "Gibraltar",
        "nom": "Gibraltar",
        "iso2": "GI",
        "iso3": "GIB",
        "phone_code": "350"
    },
    {
        "id": 77,
        "nombre": "Granada",
        "name": "Grenada",
        "nom": "Grenade",
        "iso2": "GD",
        "iso3": "GRD",
        "phone_code": "1 473"
    },
    {
        "id": 78,
        "nombre": "Grecia",
        "name": "Greece",
        "nom": "Grèce",
        "iso2": "GR",
        "iso3": "GRC",
        "phone_code": "30"
    },
    {
        "id": 79,
        "nombre": "Groenlandia",
        "name": "Greenland",
        "nom": "Groenland",
        "iso2": "GL",
        "iso3": "GRL",
        "phone_code": "299"
    },
    {
        "id": 80,
        "nombre": "Guadalupe",
        "name": "Guadeloupe",
        "nom": "Guadeloupe",
        "iso2": "GP",
        "iso3": "GLP",
        "phone_code": ""
    },
    {
        "id": 81,
        "nombre": "Guam",
        "name": "Guam",
        "nom": "Guam",
        "iso2": "GU",
        "iso3": "GUM",
        "phone_code": "1 671"
    },
    {
        "id": 82,
        "nombre": "Guatemala",
        "name": "Guatemala",
        "nom": "Guatemala",
        "iso2": "GT",
        "iso3": "GTM",
        "phone_code": "502"
    },
    {
        "id": 83,
        "nombre": "Guayana Francesa",
        "name": "French Guiana",
        "nom": "Guyane française",
        "iso2": "GF",
        "iso3": "GUF",
        "phone_code": ""
    },
    {
        "id": 84,
        "nombre": "Guernsey",
        "name": "Guernsey",
        "nom": "Guernesey",
        "iso2": "GG",
        "iso3": "GGY",
        "phone_code": ""
    },
    {
        "id": 85,
        "nombre": "Guinea",
        "name": "Guinea",
        "nom": "Guinée",
        "iso2": "GN",
        "iso3": "GIN",
        "phone_code": "224"
    },
    {
        "id": 86,
        "nombre": "Guinea Ecuatorial",
        "name": "Equatorial Guinea",
        "nom": "Guinée Equatoriale",
        "iso2": "GQ",
        "iso3": "GNQ",
        "phone_code": "240"
    },
    {
        "id": 87,
        "nombre": "Guinea-Bissau",
        "name": "Guinea-Bissau",
        "nom": "Guinée-Bissau",
        "iso2": "GW",
        "iso3": "GNB",
        "phone_code": "245"
    },
    {
        "id": 88,
        "nombre": "Guyana",
        "name": "Guyana",
        "nom": "Guyane",
        "iso2": "GY",
        "iso3": "GUY",
        "phone_code": "592"
    },
    {
        "id": 89,
        "nombre": "Haití",
        "name": "Haiti",
        "nom": "Haïti",
        "iso2": "HT",
        "iso3": "HTI",
        "phone_code": "509"
    },
    {
        "id": 90,
        "nombre": "Honduras",
        "name": "Honduras",
        "nom": "Honduras",
        "iso2": "HN",
        "iso3": "HND",
        "phone_code": "504"
    },
    {
        "id": 91,
        "nombre": "Hong kong",
        "name": "Hong Kong",
        "nom": "Hong Kong",
        "iso2": "HK",
        "iso3": "HKG",
        "phone_code": "852"
    },
    {
        "id": 92,
        "nombre": "Hungría",
        "name": "Hungary",
        "nom": "Hongrie",
        "iso2": "HU",
        "iso3": "HUN",
        "phone_code": "36"
    },
    {
        "id": 93,
        "nombre": "India",
        "name": "India",
        "nom": "Inde",
        "iso2": "IN",
        "iso3": "IND",
        "phone_code": "91"
    },
    {
        "id": 94,
        "nombre": "Indonesia",
        "name": "Indonesia",
        "nom": "Indonésie",
        "iso2": "ID",
        "iso3": "IDN",
        "phone_code": "62"
    },
    {
        "id": 95,
        "nombre": "Irán",
        "name": "Iran",
        "nom": "Iran",
        "iso2": "IR",
        "iso3": "IRN",
        "phone_code": "98"
    },
    {
        "id": 96,
        "nombre": "Irak",
        "name": "Iraq",
        "nom": "Irak",
        "iso2": "IQ",
        "iso3": "IRQ",
        "phone_code": "964"
    },
    {
        "id": 97,
        "nombre": "Irlanda",
        "name": "Ireland",
        "nom": "Irlande",
        "iso2": "IE",
        "iso3": "IRL",
        "phone_code": "353"
    },
    {
        "id": 98,
        "nombre": "Isla Bouvet",
        "name": "Bouvet Island",
        "nom": "Bouvet Island",
        "iso2": "BV",
        "iso3": "BVT",
        "phone_code": ""
    },
    {
        "id": 99,
        "nombre": "Isla de Man",
        "name": "Isle of Man",
        "nom": "Ile de Man",
        "iso2": "IM",
        "iso3": "IMN",
        "phone_code": "44"
    },
    {
        "id": 100,
        "nombre": "Isla de Navidad",
        "name": "Christmas Island",
        "nom": "Christmas Island",
        "iso2": "CX",
        "iso3": "CXR",
        "phone_code": "61"
    },
    {
        "id": 101,
        "nombre": "Isla Norfolk",
        "name": "Norfolk Island",
        "nom": "Île de Norfolk",
        "iso2": "NF",
        "iso3": "NFK",
        "phone_code": ""
    },
    {
        "id": 102,
        "nombre": "Islandia",
        "name": "Iceland",
        "nom": "Islande",
        "iso2": "IS",
        "iso3": "ISL",
        "phone_code": "354"
    },
    {
        "id": 103,
        "nombre": "Islas Bermudas",
        "name": "Bermuda Islands",
        "nom": "Bermudes",
        "iso2": "BM",
        "iso3": "BMU",
        "phone_code": "1 441"
    },
    {
        "id": 104,
        "nombre": "Islas Caimán",
        "name": "Cayman Islands",
        "nom": "Iles Caïmans",
        "iso2": "KY",
        "iso3": "CYM",
        "phone_code": "1 345"
    },
    {
        "id": 105,
        "nombre": "Islas Cocos (Keeling)",
        "name": "Cocos (Keeling) Islands",
        "nom": "Cocos (Keeling",
        "iso2": "CC",
        "iso3": "CCK",
        "phone_code": "61"
    },
    {
        "id": 106,
        "nombre": "Islas Cook",
        "name": "Cook Islands",
        "nom": "Iles Cook",
        "iso2": "CK",
        "iso3": "COK",
        "phone_code": "682"
    },
    {
        "id": 107,
        "nombre": "Islas de Åland",
        "name": "Åland Islands",
        "nom": "Îles Åland",
        "iso2": "AX",
        "iso3": "ALA",
        "phone_code": ""
    },
    {
        "id": 108,
        "nombre": "Islas Feroe",
        "name": "Faroe Islands",
        "nom": "Iles Féro",
        "iso2": "FO",
        "iso3": "FRO",
        "phone_code": "298"
    },
    {
        "id": 109,
        "nombre": "Islas Georgias del Sur y Sandwich del Sur",
        "name": "South Georgia and the South Sandwich Islands",
        "nom": "Géorgie du Sud et les Îles Sandwich du Sud",
        "iso2": "GS",
        "iso3": "SGS",
        "phone_code": ""
    },
    {
        "id": 110,
        "nombre": "Islas Heard y McDonald",
        "name": "Heard Island and McDonald Islands",
        "nom": "Les îles Heard et McDonald",
        "iso2": "HM",
        "iso3": "HMD",
        "phone_code": ""
    },
    {
        "id": 111,
        "nombre": "Islas Maldivas",
        "name": "Maldives",
        "nom": "Maldives",
        "iso2": "MV",
        "iso3": "MDV",
        "phone_code": "960"
    },
    {
        "id": 112,
        "nombre": "Islas Malvinas",
        "name": "Falkland Islands (Malvinas)",
        "nom": "Iles Falkland (Malvinas",
        "iso2": "FK",
        "iso3": "FLK",
        "phone_code": "500"
    },
    {
        "id": 113,
        "nombre": "Islas Marianas del Norte",
        "name": "Northern Mariana Islands",
        "nom": "Iles Mariannes du Nord",
        "iso2": "MP",
        "iso3": "MNP",
        "phone_code": "1 670"
    },
    {
        "id": 114,
        "nombre": "Islas Marshall",
        "name": "Marshall Islands",
        "nom": "Iles Marshall",
        "iso2": "MH",
        "iso3": "MHL",
        "phone_code": "692"
    },
    {
        "id": 115,
        "nombre": "Islas Pitcairn",
        "name": "Pitcairn Islands",
        "nom": "Iles Pitcairn",
        "iso2": "PN",
        "iso3": "PCN",
        "phone_code": "870"
    },
    {
        "id": 116,
        "nombre": "Islas Salomón",
        "name": "Solomon Islands",
        "nom": "Iles Salomon",
        "iso2": "SB",
        "iso3": "SLB",
        "phone_code": "677"
    },
    {
        "id": 117,
        "nombre": "Islas Turcas y Caicos",
        "name": "Turks and Caicos Islands",
        "nom": "Iles Turques et Caïques",
        "iso2": "TC",
        "iso3": "TCA",
        "phone_code": "1 649"
    },
    {
        "id": 118,
        "nombre": "Islas Ultramarinas Menores de Estados Unidos",
        "name": "United States Minor Outlying Islands",
        "nom": "États-Unis Îles mineures éloignées",
        "iso2": "UM",
        "iso3": "UMI",
        "phone_code": ""
    },
    {
        "id": 119,
        "nombre": "Islas Vírgenes Británicas",
        "name": "Virgin Islands",
        "nom": "Iles Vierges",
        "iso2": "VG",
        "iso3": "VG",
        "phone_code": "1 284"
    },
    {
        "id": 120,
        "nombre": "Islas Vírgenes de los Estados Unidos",
        "name": "United States Virgin Islands",
        "nom": "Îles Vierges américaines",
        "iso2": "VI",
        "iso3": "VIR",
        "phone_code": "1 340"
    },
    {
        "id": 121,
        "nombre": "Israel",
        "name": "Israel",
        "nom": "Israël",
        "iso2": "IL",
        "iso3": "ISR",
        "phone_code": "972"
    },
    {
        "id": 122,
        "nombre": "Italia",
        "name": "Italy",
        "nom": "Italie",
        "iso2": "IT",
        "iso3": "ITA",
        "phone_code": "39"
    },
    {
        "id": 123,
        "nombre": "Jamaica",
        "name": "Jamaica",
        "nom": "Jamaïque",
        "iso2": "JM",
        "iso3": "JAM",
        "phone_code": "1 876"
    },
    {
        "id": 124,
        "nombre": "Japón",
        "name": "Japan",
        "nom": "Japon",
        "iso2": "JP",
        "iso3": "JPN",
        "phone_code": "81"
    },
    {
        "id": 125,
        "nombre": "Jersey",
        "name": "Jersey",
        "nom": "Maillot",
        "iso2": "JE",
        "iso3": "JEY",
        "phone_code": ""
    },
    {
        "id": 126,
        "nombre": "Jordania",
        "name": "Jordan",
        "nom": "Jordan",
        "iso2": "JO",
        "iso3": "JOR",
        "phone_code": "962"
    },
    {
        "id": 127,
        "nombre": "Kazajistán",
        "name": "Kazakhstan",
        "nom": "Le Kazakhstan",
        "iso2": "KZ",
        "iso3": "KAZ",
        "phone_code": "7"
    },
    {
        "id": 128,
        "nombre": "Kenia",
        "name": "Kenya",
        "nom": "Kenya",
        "iso2": "KE",
        "iso3": "KEN",
        "phone_code": "254"
    },
    {
        "id": 129,
        "nombre": "Kirgizstán",
        "name": "Kyrgyzstan",
        "nom": "Kirghizstan",
        "iso2": "KG",
        "iso3": "KGZ",
        "phone_code": "996"
    },
    {
        "id": 130,
        "nombre": "Kiribati",
        "name": "Kiribati",
        "nom": "Kiribati",
        "iso2": "KI",
        "iso3": "KIR",
        "phone_code": "686"
    },
    {
        "id": 131,
        "nombre": "Kuwait",
        "name": "Kuwait",
        "nom": "Koweït",
        "iso2": "KW",
        "iso3": "KWT",
        "phone_code": "965"
    },
    {
        "id": 132,
        "nombre": "Líbano",
        "name": "Lebanon",
        "nom": "Liban",
        "iso2": "LB",
        "iso3": "LBN",
        "phone_code": "961"
    },
    {
        "id": 133,
        "nombre": "Laos",
        "name": "Laos",
        "nom": "Laos",
        "iso2": "LA",
        "iso3": "LAO",
        "phone_code": "856"
    },
    {
        "id": 134,
        "nombre": "Lesoto",
        "name": "Lesotho",
        "nom": "Lesotho",
        "iso2": "LS",
        "iso3": "LSO",
        "phone_code": "266"
    },
    {
        "id": 135,
        "nombre": "Letonia",
        "name": "Latvia",
        "nom": "La Lettonie",
        "iso2": "LV",
        "iso3": "LVA",
        "phone_code": "371"
    },
    {
        "id": 136,
        "nombre": "Liberia",
        "name": "Liberia",
        "nom": "Liberia",
        "iso2": "LR",
        "iso3": "LBR",
        "phone_code": "231"
    },
    {
        "id": 137,
        "nombre": "Libia",
        "name": "Libya",
        "nom": "Libye",
        "iso2": "LY",
        "iso3": "LBY",
        "phone_code": "218"
    },
    {
        "id": 138,
        "nombre": "Liechtenstein",
        "name": "Liechtenstein",
        "nom": "Liechtenstein",
        "iso2": "LI",
        "iso3": "LIE",
        "phone_code": "423"
    },
    {
        "id": 139,
        "nombre": "Lituania",
        "name": "Lithuania",
        "nom": "La Lituanie",
        "iso2": "LT",
        "iso3": "LTU",
        "phone_code": "370"
    },
    {
        "id": 140,
        "nombre": "Luxemburgo",
        "name": "Luxembourg",
        "nom": "Luxembourg",
        "iso2": "LU",
        "iso3": "LUX",
        "phone_code": "352"
    },
    {
        "id": 141,
        "nombre": "México",
        "name": "Mexico",
        "nom": "Mexique",
        "iso2": "MX",
        "iso3": "MEX",
        "phone_code": "52"
    },
    {
        "id": 142,
        "nombre": "Mónaco",
        "name": "Monaco",
        "nom": "Monaco",
        "iso2": "MC",
        "iso3": "MCO",
        "phone_code": "377"
    },
    {
        "id": 143,
        "nombre": "Macao",
        "name": "Macao",
        "nom": "Macao",
        "iso2": "MO",
        "iso3": "MAC",
        "phone_code": "853"
    },
    {
        "id": 144,
        "nombre": "Macedônia",
        "name": "Macedonia",
        "nom": "Macédoine",
        "iso2": "MK",
        "iso3": "MKD",
        "phone_code": "389"
    },
    {
        "id": 145,
        "nombre": "Madagascar",
        "name": "Madagascar",
        "nom": "Madagascar",
        "iso2": "MG",
        "iso3": "MDG",
        "phone_code": "261"
    },
    {
        "id": 146,
        "nombre": "Malasia",
        "name": "Malaysia",
        "nom": "Malaisie",
        "iso2": "MY",
        "iso3": "MYS",
        "phone_code": "60"
    },
    {
        "id": 147,
        "nombre": "Malawi",
        "name": "Malawi",
        "nom": "Malawi",
        "iso2": "MW",
        "iso3": "MWI",
        "phone_code": "265"
    },
    {
        "id": 148,
        "nombre": "Mali",
        "name": "Mali",
        "nom": "Mali",
        "iso2": "ML",
        "iso3": "MLI",
        "phone_code": "223"
    },
    {
        "id": 149,
        "nombre": "Malta",
        "name": "Malta",
        "nom": "Malte",
        "iso2": "MT",
        "iso3": "MLT",
        "phone_code": "356"
    },
    {
        "id": 150,
        "nombre": "Marruecos",
        "name": "Morocco",
        "nom": "Maroc",
        "iso2": "MA",
        "iso3": "MAR",
        "phone_code": "212"
    },
    {
        "id": 151,
        "nombre": "Martinica",
        "name": "Martinique",
        "nom": "Martinique",
        "iso2": "MQ",
        "iso3": "MTQ",
        "phone_code": ""
    },
    {
        "id": 152,
        "nombre": "Mauricio",
        "name": "Mauritius",
        "nom": "Iles Maurice",
        "iso2": "MU",
        "iso3": "MUS",
        "phone_code": "230"
    },
    {
        "id": 153,
        "nombre": "Mauritania",
        "name": "Mauritania",
        "nom": "Mauritanie",
        "iso2": "MR",
        "iso3": "MRT",
        "phone_code": "222"
    },
    {
        "id": 154,
        "nombre": "Mayotte",
        "name": "Mayotte",
        "nom": "Mayotte",
        "iso2": "YT",
        "iso3": "MYT",
        "phone_code": "262"
    },
    {
        "id": 155,
        "nombre": "Micronesia",
        "name": "Estados Federados de",
        "nom": "Federados Estados de",
        "iso2": "FM",
        "iso3": "FSM",
        "phone_code": "691"
    },
    {
        "id": 156,
        "nombre": "Moldavia",
        "name": "Moldova",
        "nom": "Moldavie",
        "iso2": "MD",
        "iso3": "MDA",
        "phone_code": "373"
    },
    {
        "id": 157,
        "nombre": "Mongolia",
        "name": "Mongolia",
        "nom": "Mongolie",
        "iso2": "MN",
        "iso3": "MNG",
        "phone_code": "976"
    },
    {
        "id": 158,
        "nombre": "Montenegro",
        "name": "Montenegro",
        "nom": "Monténégro",
        "iso2": "ME",
        "iso3": "MNE",
        "phone_code": "382"
    },
    {
        "id": 159,
        "nombre": "Montserrat",
        "name": "Montserrat",
        "nom": "Montserrat",
        "iso2": "MS",
        "iso3": "MSR",
        "phone_code": "1 664"
    },
    {
        "id": 160,
        "nombre": "Mozambique",
        "name": "Mozambique",
        "nom": "Mozambique",
        "iso2": "MZ",
        "iso3": "MOZ",
        "phone_code": "258"
    },
    {
        "id": 161,
        "nombre": "Namibia",
        "name": "Namibia",
        "nom": "Namibie",
        "iso2": "NA",
        "iso3": "NAM",
        "phone_code": "264"
    },
    {
        "id": 162,
        "nombre": "Nauru",
        "name": "Nauru",
        "nom": "Nauru",
        "iso2": "NR",
        "iso3": "NRU",
        "phone_code": "674"
    },
    {
        "id": 163,
        "nombre": "Nepal",
        "name": "Nepal",
        "nom": "Népal",
        "iso2": "NP",
        "iso3": "NPL",
        "phone_code": "977"
    },
    {
        "id": 164,
        "nombre": "Nicaragua",
        "name": "Nicaragua",
        "nom": "Nicaragua",
        "iso2": "NI",
        "iso3": "NIC",
        "phone_code": "505"
    },
    {
        "id": 165,
        "nombre": "Niger",
        "name": "Niger",
        "nom": "Niger",
        "iso2": "NE",
        "iso3": "NER",
        "phone_code": "227"
    },
    {
        "id": 166,
        "nombre": "Nigeria",
        "name": "Nigeria",
        "nom": "Nigeria",
        "iso2": "NG",
        "iso3": "NGA",
        "phone_code": "234"
    },
    {
        "id": 167,
        "nombre": "Niue",
        "name": "Niue",
        "nom": "Niou",
        "iso2": "NU",
        "iso3": "NIU",
        "phone_code": "683"
    },
    {
        "id": 168,
        "nombre": "Noruega",
        "name": "Norway",
        "nom": "Norvège",
        "iso2": "NO",
        "iso3": "NOR",
        "phone_code": "47"
    },
    {
        "id": 169,
        "nombre": "Nueva Caledonia",
        "name": "New Caledonia",
        "nom": "Nouvelle-Calédonie",
        "iso2": "NC",
        "iso3": "NCL",
        "phone_code": "687"
    },
    {
        "id": 170,
        "nombre": "Nueva Zelanda",
        "name": "New Zealand",
        "nom": "Nouvelle-Zélande",
        "iso2": "NZ",
        "iso3": "NZL",
        "phone_code": "64"
    },
    {
        "id": 171,
        "nombre": "Omán",
        "name": "Oman",
        "nom": "Oman",
        "iso2": "OM",
        "iso3": "OMN",
        "phone_code": "968"
    },
    {
        "id": 172,
        "nombre": "Países Bajos",
        "name": "Netherlands",
        "nom": "Pays-Bas",
        "iso2": "NL",
        "iso3": "NLD",
        "phone_code": "31"
    },
    {
        "id": 173,
        "nombre": "Pakistán",
        "name": "Pakistan",
        "nom": "Pakistan",
        "iso2": "PK",
        "iso3": "PAK",
        "phone_code": "92"
    },
    {
        "id": 174,
        "nombre": "Palau",
        "name": "Palau",
        "nom": "Palau",
        "iso2": "PW",
        "iso3": "PLW",
        "phone_code": "680"
    },
    {
        "id": 175,
        "nombre": "Palestina",
        "name": "Palestine",
        "nom": "La Palestine",
        "iso2": "PS",
        "iso3": "PSE",
        "phone_code": ""
    },
    {
        "id": 176,
        "nombre": "Panamá",
        "name": "Panama",
        "nom": "Panama",
        "iso2": "PA",
        "iso3": "PAN",
        "phone_code": "507"
    },
    {
        "id": 177,
        "nombre": "Papúa Nueva Guinea",
        "name": "Papua New Guinea",
        "nom": "Papouasie-Nouvelle-Guinée",
        "iso2": "PG",
        "iso3": "PNG",
        "phone_code": "675"
    },
    {
        "id": 178,
        "nombre": "Paraguay",
        "name": "Paraguay",
        "nom": "Paraguay",
        "iso2": "PY",
        "iso3": "PRY",
        "phone_code": "595"
    },
    {
        "id": 179,
        "nombre": "Perú",
        "name": "Peru",
        "nom": "Pérou",
        "iso2": "PE",
        "iso3": "PER",
        "phone_code": "51"
    },
    {
        "id": 180,
        "nombre": "Polinesia Francesa",
        "name": "French Polynesia",
        "nom": "Polynésie française",
        "iso2": "PF",
        "iso3": "PYF",
        "phone_code": "689"
    },
    {
        "id": 181,
        "nombre": "Polonia",
        "name": "Poland",
        "nom": "Pologne",
        "iso2": "PL",
        "iso3": "POL",
        "phone_code": "48"
    },
    {
        "id": 182,
        "nombre": "Portugal",
        "name": "Portugal",
        "nom": "Portugal",
        "iso2": "PT",
        "iso3": "PRT",
        "phone_code": "351"
    },
    {
        "id": 183,
        "nombre": "Puerto Rico",
        "name": "Puerto Rico",
        "nom": "Porto Rico",
        "iso2": "PR",
        "iso3": "PRI",
        "phone_code": "1"
    },
    {
        "id": 184,
        "nombre": "Qatar",
        "name": "Qatar",
        "nom": "Qatar",
        "iso2": "QA",
        "iso3": "QAT",
        "phone_code": "974"
    },
    {
        "id": 185,
        "nombre": "Reino Unido",
        "name": "United Kingdom",
        "nom": "Royaume-Uni",
        "iso2": "GB",
        "iso3": "GBR",
        "phone_code": "44"
    },
    {
        "id": 186,
        "nombre": "República Centroafricana",
        "name": "Central African Republic",
        "nom": "République Centrafricaine",
        "iso2": "CF",
        "iso3": "CAF",
        "phone_code": "236"
    },
    {
        "id": 187,
        "nombre": "República Checa",
        "name": "Czech Republic",
        "nom": "République Tchèque",
        "iso2": "CZ",
        "iso3": "CZE",
        "phone_code": "420"
    },
    {
        "id": 188,
        "nombre": "República Dominicana",
        "name": "Dominican Republic",
        "nom": "République Dominicaine",
        "iso2": "DO",
        "iso3": "DOM",
        "phone_code": "1 809"
    },
    {
        "id": 189,
        "nombre": "Reunión",
        "name": "Réunion",
        "nom": "Réunion",
        "iso2": "RE",
        "iso3": "REU",
        "phone_code": ""
    },
    {
        "id": 190,
        "nombre": "Ruanda",
        "name": "Rwanda",
        "nom": "Rwanda",
        "iso2": "RW",
        "iso3": "RWA",
        "phone_code": "250"
    },
    {
        "id": 191,
        "nombre": "Rumanía",
        "name": "Romania",
        "nom": "Roumanie",
        "iso2": "RO",
        "iso3": "ROU",
        "phone_code": "40"
    },
    {
        "id": 192,
        "nombre": "Rusia",
        "name": "Russia",
        "nom": "La Russie",
        "iso2": "RU",
        "iso3": "RUS",
        "phone_code": "7"
    },
    {
        "id": 193,
        "nombre": "Sahara Occidental",
        "name": "Western Sahara",
        "nom": "Sahara Occidental",
        "iso2": "EH",
        "iso3": "ESH",
        "phone_code": ""
    },
    {
        "id": 194,
        "nombre": "Samoa",
        "name": "Samoa",
        "nom": "Samoa",
        "iso2": "WS",
        "iso3": "WSM",
        "phone_code": "685"
    },
    {
        "id": 195,
        "nombre": "Samoa Americana",
        "name": "American Samoa",
        "nom": "Les Samoa américaines",
        "iso2": "AS",
        "iso3": "ASM",
        "phone_code": "1 684"
    },
    {
        "id": 196,
        "nombre": "San Bartolomé",
        "name": "Saint Barthélemy",
        "nom": "Saint-Barthélemy",
        "iso2": "BL",
        "iso3": "BLM",
        "phone_code": "590"
    },
    {
        "id": 197,
        "nombre": "San Cristóbal y Nieves",
        "name": "Saint Kitts and Nevis",
        "nom": "Saint Kitts et Nevis",
        "iso2": "KN",
        "iso3": "KNA",
        "phone_code": "1 869"
    },
    {
        "id": 198,
        "nombre": "San Marino",
        "name": "San Marino",
        "nom": "San Marino",
        "iso2": "SM",
        "iso3": "SMR",
        "phone_code": "378"
    },
    {
        "id": 199,
        "nombre": "San Martín (Francia)",
        "name": "Saint Martin (French part)",
        "nom": "Saint-Martin (partie française)",
        "iso2": "MF",
        "iso3": "MAF",
        "phone_code": "1 599"
    },
    {
        "id": 200,
        "nombre": "San Pedro y Miquelón",
        "name": "Saint Pierre and Miquelon",
        "nom": "Saint-Pierre-et-Miquelon",
        "iso2": "PM",
        "iso3": "SPM",
        "phone_code": "508"
    },
    {
        "id": 201,
        "nombre": "San Vicente y las Granadinas",
        "name": "Saint Vincent and the Grenadines",
        "nom": "Saint-Vincent et Grenadines",
        "iso2": "VC",
        "iso3": "VCT",
        "phone_code": "1 784"
    },
    {
        "id": 202,
        "nombre": "Santa Elena",
        "name": "Ascensión y Tristán de Acuña",
        "nom": "Ascensión y Tristan de Acuña",
        "iso2": "SH",
        "iso3": "SHN",
        "phone_code": "290"
    },
    {
        "id": 203,
        "nombre": "Santa Lucía",
        "name": "Saint Lucia",
        "nom": "Sainte-Lucie",
        "iso2": "LC",
        "iso3": "LCA",
        "phone_code": "1 758"
    },
    {
        "id": 204,
        "nombre": "Santo Tomé y Príncipe",
        "name": "Sao Tome and Principe",
        "nom": "Sao Tomé et Principe",
        "iso2": "ST",
        "iso3": "STP",
        "phone_code": "239"
    },
    {
        "id": 205,
        "nombre": "Senegal",
        "name": "Senegal",
        "nom": "Sénégal",
        "iso2": "SN",
        "iso3": "SEN",
        "phone_code": "221"
    },
    {
        "id": 206,
        "nombre": "Serbia",
        "name": "Serbia",
        "nom": "Serbie",
        "iso2": "RS",
        "iso3": "SRB",
        "phone_code": "381"
    },
    {
        "id": 207,
        "nombre": "Seychelles",
        "name": "Seychelles",
        "nom": "Les Seychelles",
        "iso2": "SC",
        "iso3": "SYC",
        "phone_code": "248"
    },
    {
        "id": 208,
        "nombre": "Sierra Leona",
        "name": "Sierra Leone",
        "nom": "Sierra Leone",
        "iso2": "SL",
        "iso3": "SLE",
        "phone_code": "232"
    },
    {
        "id": 209,
        "nombre": "Singapur",
        "name": "Singapore",
        "nom": "Singapour",
        "iso2": "SG",
        "iso3": "SGP",
        "phone_code": "65"
    },
    {
        "id": 210,
        "nombre": "Siria",
        "name": "Syria",
        "nom": "Syrie",
        "iso2": "SY",
        "iso3": "SYR",
        "phone_code": "963"
    },
    {
        "id": 211,
        "nombre": "Somalia",
        "name": "Somalia",
        "nom": "Somalie",
        "iso2": "SO",
        "iso3": "SOM",
        "phone_code": "252"
    },
    {
        "id": 212,
        "nombre": "Sri lanka",
        "name": "Sri Lanka",
        "nom": "Sri Lanka",
        "iso2": "LK",
        "iso3": "LKA",
        "phone_code": "94"
    },
    {
        "id": 213,
        "nombre": "Sudáfrica",
        "name": "South Africa",
        "nom": "Afrique du Sud",
        "iso2": "ZA",
        "iso3": "ZAF",
        "phone_code": "27"
    },
    {
        "id": 214,
        "nombre": "Sudán",
        "name": "Sudan",
        "nom": "Soudan",
        "iso2": "SD",
        "iso3": "SDN",
        "phone_code": "249"
    },
    {
        "id": 215,
        "nombre": "Suecia",
        "name": "Sweden",
        "nom": "Suède",
        "iso2": "SE",
        "iso3": "SWE",
        "phone_code": "46"
    },
    {
        "id": 216,
        "nombre": "Suiza",
        "name": "Switzerland",
        "nom": "Suisse",
        "iso2": "CH",
        "iso3": "CHE",
        "phone_code": "41"
    },
    {
        "id": 217,
        "nombre": "Surinám",
        "name": "Suriname",
        "nom": "Surinam",
        "iso2": "SR",
        "iso3": "SUR",
        "phone_code": "597"
    },
    {
        "id": 218,
        "nombre": "Svalbard y Jan Mayen",
        "name": "Svalbard and Jan Mayen",
        "nom": "Svalbard et Jan Mayen",
        "iso2": "SJ",
        "iso3": "SJM",
        "phone_code": ""
    },
    {
        "id": 219,
        "nombre": "Swazilandia",
        "name": "Swaziland",
        "nom": "Swaziland",
        "iso2": "SZ",
        "iso3": "SWZ",
        "phone_code": "268"
    },
    {
        "id": 220,
        "nombre": "Tadjikistán",
        "name": "Tajikistan",
        "nom": "Le Tadjikistan",
        "iso2": "TJ",
        "iso3": "TJK",
        "phone_code": "992"
    },
    {
        "id": 221,
        "nombre": "Tailandia",
        "name": "Thailand",
        "nom": "Thaïlande",
        "iso2": "TH",
        "iso3": "THA",
        "phone_code": "66"
    },
    {
        "id": 222,
        "nombre": "Taiwán",
        "name": "Taiwan",
        "nom": "Taiwan",
        "iso2": "TW",
        "iso3": "TWN",
        "phone_code": "886"
    },
    {
        "id": 223,
        "nombre": "Tanzania",
        "name": "Tanzania",
        "nom": "Tanzanie",
        "iso2": "TZ",
        "iso3": "TZA",
        "phone_code": "255"
    },
    {
        "id": 224,
        "nombre": "Territorio Británico del Océano Índico",
        "name": "British Indian Ocean Territory",
        "nom": "Territoire britannique de locéan Indien",
        "iso2": "IO",
        "iso3": "IOT",
        "phone_code": ""
    },
    {
        "id": 225,
        "nombre": "Territorios Australes y Antárticas Franceses",
        "name": "French Southern Territories",
        "nom": "Terres australes françaises",
        "iso2": "TF",
        "iso3": "ATF",
        "phone_code": ""
    },
    {
        "id": 226,
        "nombre": "Timor Oriental",
        "name": "East Timor",
        "nom": "Timor-Oriental",
        "iso2": "TL",
        "iso3": "TLS",
        "phone_code": "670"
    },
    {
        "id": 227,
        "nombre": "Togo",
        "name": "Togo",
        "nom": "Togo",
        "iso2": "TG",
        "iso3": "TGO",
        "phone_code": "228"
    },
    {
        "id": 228,
        "nombre": "Tokelau",
        "name": "Tokelau",
        "nom": "Tokélaou",
        "iso2": "TK",
        "iso3": "TKL",
        "phone_code": "690"
    },
    {
        "id": 229,
        "nombre": "Tonga",
        "name": "Tonga",
        "nom": "Tonga",
        "iso2": "TO",
        "iso3": "TON",
        "phone_code": "676"
    },
    {
        "id": 230,
        "nombre": "Trinidad y Tobago",
        "name": "Trinidad and Tobago",
        "nom": "Trinidad et Tobago",
        "iso2": "TT",
        "iso3": "TTO",
        "phone_code": "1 868"
    },
    {
        "id": 231,
        "nombre": "Tunez",
        "name": "Tunisia",
        "nom": "Tunisie",
        "iso2": "TN",
        "iso3": "TUN",
        "phone_code": "216"
    },
    {
        "id": 232,
        "nombre": "Turkmenistán",
        "name": "Turkmenistan",
        "nom": "Le Turkménistan",
        "iso2": "TM",
        "iso3": "TKM",
        "phone_code": "993"
    },
    {
        "id": 233,
        "nombre": "Turquía",
        "name": "Turkey",
        "nom": "Turquie",
        "iso2": "TR",
        "iso3": "TUR",
        "phone_code": "90"
    },
    {
        "id": 234,
        "nombre": "Tuvalu",
        "name": "Tuvalu",
        "nom": "Tuvalu",
        "iso2": "TV",
        "iso3": "TUV",
        "phone_code": "688"
    },
    {
        "id": 235,
        "nombre": "Ucrania",
        "name": "Ukraine",
        "nom": "LUkraine",
        "iso2": "UA",
        "iso3": "UKR",
        "phone_code": "380"
    },
    {
        "id": 236,
        "nombre": "Uganda",
        "name": "Uganda",
        "nom": "Ouganda",
        "iso2": "UG",
        "iso3": "UGA",
        "phone_code": "256"
    },
    {
        "id": 237,
        "nombre": "Uruguay",
        "name": "Uruguay",
        "nom": "Uruguay",
        "iso2": "UY",
        "iso3": "URY",
        "phone_code": "598"
    },
    {
        "id": 238,
        "nombre": "Uzbekistán",
        "name": "Uzbekistan",
        "nom": "LOuzbékistan",
        "iso2": "UZ",
        "iso3": "UZB",
        "phone_code": "998"
    },
    {
        "id": 239,
        "nombre": "Vanuatu",
        "name": "Vanuatu",
        "nom": "Vanuatu",
        "iso2": "VU",
        "iso3": "VUT",
        "phone_code": "678"
    },
    {
        "id": 240,
        "nombre": "Venezuela",
        "name": "Venezuela",
        "nom": "Venezuela",
        "iso2": "VE",
        "iso3": "VEN",
        "phone_code": "58"
    },
    {
        "id": 241,
        "nombre": "Vietnam",
        "name": "Vietnam",
        "nom": "Vietnam",
        "iso2": "VN",
        "iso3": "VNM",
        "phone_code": "84"
    },
    {
        "id": 242,
        "nombre": "Wallis y Futuna",
        "name": "Wallis and Futuna",
        "nom": "Wallis et Futuna",
        "iso2": "WF",
        "iso3": "WLF",
        "phone_code": "681"
    },
    {
        "id": 243,
        "nombre": "Yemen",
        "name": "Yemen",
        "nom": "Yémen",
        "iso2": "YE",
        "iso3": "YEM",
        "phone_code": "967"
    },
    {
        "id": 244,
        "nombre": "Yibuti",
        "name": "Djibouti",
        "nom": "Djibouti",
        "iso2": "DJ",
        "iso3": "DJI",
        "phone_code": "253"
    },
    {
        "id": 245,
        "nombre": "Zambia",
        "name": "Zambia",
        "nom": "Zambie",
        "iso2": "ZM",
        "iso3": "ZMB",
        "phone_code": "260"
    },
    {
        "id": 246,
        "nombre": "Zimbabue",
        "name": "Zimbabwe",
        "nom": "Zimbabwe",
        "iso2": "ZW",
        "iso3": "ZWE",
        "phone_code": "263"
    }
];